module.exports = __webpack_public_path__ + "img/full2-min.df90a2e7.png";